<template>
  <q-dialog :model-value="modelValue" @update:model-value="fechar">
    <q-card class="neg-escopo neg-modal neg-modal--largo">
      <q-card-section class="neg-modal__titulo">
        Linhas de crédito
        <div class="neg-sub">Os produtos que a lotérica vende e o percentual de comissão padrão</div>
      </q-card-section>

      <q-card-section v-if="!emEdicao" class="neg-modal__corpo">
        <div v-for="linha in negociosLinhas" :key="linha.id" class="neg-etapa">
          <span class="neg-etapa__nome">
            {{ linha.nome }}
            <div class="neg-sub">{{ descricaoDaLinha(linha) }}</div>
          </span>
          <q-btn flat dense icon="edit" @click="editar(linha)">
            <q-tooltip>Editar</q-tooltip>
          </q-btn>
          <q-btn flat dense icon="delete" color="negative" @click="excluir(linha)">
            <q-tooltip>Excluir ou desativar</q-tooltip>
          </q-btn>
        </div>
        <div v-if="!negociosLinhas.length" class="neg-sub">Nenhuma linha cadastrada</div>
      </q-card-section>

      <q-card-section v-else class="neg-modal__corpo">
        <q-input
          v-model="emEdicao.nome"
          autofocus
          dense
          label="Nome"
          :error="Boolean(erros.nome)"
          :error-message="primeiroErro('nome')"
        />
        <q-input
          v-model="emEdicao.categoria"
          dense
          clearable
          label="Categoria"
          hint="Consignado, FGTS, Seguro..."
          :error="Boolean(erros.categoria)"
          :error-message="primeiroErro('categoria')"
        />
        <q-input
          v-model="emEdicao.banco"
          dense
          clearable
          label="Banco ou parceiro"
          :error="Boolean(erros.banco)"
          :error-message="primeiroErro('banco')"
        />
        <q-input
          :model-value="emEdicao.percentual_comissao"
          @update:model-value="emEdicao.percentual_comissao = $numero($event)"
          dense
          clearable
          type="number"
          step="0.001"
          label="Percentual de comissão (%)"
          hint="Copiado para a oportunidade no momento em que ela é aberta"
          :error="Boolean(erros.percentual_comissao)"
          :error-message="primeiroErro('percentual_comissao')"
        />
        <q-toggle v-model="emEdicao.ativo" label="Aceita oportunidade nova" />
      </q-card-section>

      <q-card-actions align="right">
        <template v-if="emEdicao">
          <q-btn flat no-caps label="Voltar" @click="emEdicao = null" />
          <q-btn
            unelevated
            no-caps
            color="primary"
            label="Salvar linha"
            :loading="salvando"
            @click="salvar"
          />
        </template>
        <template v-else>
          <q-btn flat no-caps label="Fechar" @click="fechar(false)" />
          <q-btn unelevated no-caps color="primary" icon="add" label="Nova linha" @click="criar" />
        </template>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

function linhaNova() {
  return {
    id: null,
    nome: "",
    categoria: null,
    banco: null,
    percentual_comissao: null,
    ativo: true
  };
}

export default {
  name: "negocios-modal-linhas",

  emits: ["update:modelValue"],
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emEdicao: null,
      salvando: false,
      erros: {}
    };
  },
  computed: {
    ...mapGetters(["negociosLinhas"])
  },
  methods: {
    descricaoDaLinha(linha) {
      const partes = [];

      if (linha.categoria) {
        partes.push(linha.categoria);
      }

      if (linha.banco) {
        partes.push(linha.banco);
      }

      if (linha.percentual_comissao !== null) {
        partes.push(String(linha.percentual_comissao).replace(".", ",") + " % de comissão");
      }

      if (!linha.ativo) {
        partes.push("desativada");
      }

      return partes.join(" · ");
    },
    criar() {
      this.erros = {};
      this.emEdicao = linhaNova();
    },
    editar(linha) {
      this.erros = {};
      this.emEdicao = { ...linha };
    },
    salvar() {
      this.salvando = true;
      this.erros = {};

      const id = this.emEdicao.id;
      const dados = {
        nome: this.emEdicao.nome,
        categoria: this.emEdicao.categoria,
        banco: this.emEdicao.banco,
        percentual_comissao: this.emEdicao.percentual_comissao,
        ativo: this.emEdicao.ativo
      };

      this.$store.dispatch("salvarNegociosLinha", { id, dados }).then(resposta => {
        this.salvando = false;

        if (!resposta.success) {
          this.erros = resposta.errors || {};
          this.avisar(resposta.message, "orange");
          return;
        }

        this.emEdicao = null;
        this.avisar(resposta.message, "green");
      });
    },
    excluir(linha) {
      this.$store.dispatch("excluirNegociosLinha", linha.id).then(resposta => {
        this.avisar(resposta.message, resposta.success ? "green" : "orange");
      });
    },
    fechar(aberto) {
      this.emEdicao = null;
      this.$emit("update:modelValue", aberto === true);
    }
  }
};
</script>
